import { ThisConnector } from '../../../../api/connector'

export interface SuppressEventsFromExclusionArgs {
  organizationUuid: string
  applicationId: string
  exclusionId: string
}

export interface SuppressEventsFromExclusionApiResponse {
  count: number
}

export async function suppressEventsFromExclusion(
  this: ThisConnector,
  {
    organizationUuid,
    applicationId,
    exclusionId
  }: SuppressEventsFromExclusionArgs
): Promise<SuppressEventsFromExclusionApiResponse> {
  const { count } =
    await this.connector.put<SuppressEventsFromExclusionApiResponse>(
      `/${organizationUuid}/applications/${applicationId}/exclusions/${exclusionId}/events`
    )

  return { count }
}
